export default __webpack_public_path__ + "static/media/Tobi.19a2647a.jpg";